

import { Component, Vue, Prop } from "vue-property-decorator";
import user_module from '@/modules/user/index';

@Component
export default class Product extends Vue {

  @Prop({default: ''}) img!: string;
  @Prop({default: ''}) id!: string;
  @Prop({default: ''}) name!: string;
  @Prop({default: ''}) description!: string;
  @Prop({default: false}) bought!: string;
  @Prop({default: false}) link!: string;
  @Prop({default: ''}) video!: string
  @Prop({default: ''}) landing!: string
  @Prop({default: ''}) icon!: string
  @Prop({default: ''}) productCode!: string;
  @Prop({default: false}) hideStart!: boolean;
  @Prop({default: false}) hideTrial!: boolean;
  @Prop({default: false}) hidePlay!: boolean;
  @Prop({default: '_self'}) target!: boolean;
  @Prop({default: false}) hideLearn!: boolean;

  play: boolean = false 

  get token(){

    return user_module.token;
  }

  get productIconSrc(){

    return require("@/assets/product-icons2/" + this.icon)

  }

  get expired(){
    return user_module.expired;
  }

  startPlay(){

    if (!this.hidePlay){
      this.play = true;
    }

  }

  getTrial(){

     if (this.token){

      user_module.getTrial(this.productCode);
      this.$router.push('/trial?product=' + this.productCode);  

    } else {

      this.$router.push('/trial_logout?product=' + this.productCode);  

    }

  }

  openRead(){

    console.log('open page read')
  }

  openBuy(){

    console.log('open page buy ')
  }

  openVisit(){

    console.log('open page visit')

  }

}

